var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useContext, useMemo } from '@max/max';
import View from '@hfe/max-view';
import LinearGradient from '@hfe/max-linear-gradient';
import login from '@nibfe/mkt-user-api';
import Text from '@hfe/max-text';
import { claimCoupon, CouponStatus } from '@nibfe/mkt-coupon-api';
import './index.scss';
import { EResultCode } from '../../lib/interface';
import { presendRequest } from '../../utils/coupon';
export default function AllClaimButton({ couponList, couponConfig, location, toastConfig, updateCouponList, setCurrentTimeMillis, formatCouponConfigRes, allCouponText, allCouponTextColor, allCouponColor }) {
    const { _uiInteractionAPI, _moduleId, _runtimeInfo, _raptorReport } = useContext(global._EngineGlobalContext);
    let { pageId, rootTag } = _runtimeInfo || {};
    pageId = String(pageId);
    const { reportLog } = _raptorReport || {};
    const { toast } = _uiInteractionAPI || {};
    const campaignKeys = useMemo(() => {
        return couponList.filter(item => item.status === CouponStatus.NotClaimed).map(item => item.campaignKey);
    }, [couponList]);
    // 领券
    const handleClaimCoupon = () => __awaiter(this, void 0, void 0, function* () {
        let toastTip = '';
        const claimRes = yield claimCoupon({
            campaignKeys: campaignKeys,
            campaignScene: 1,
            // campaignBizMap: getCampaignBizMap([campaignKey], formatCouponConfigRes),
            pageId,
            moduleId: _moduleId,
            mmcParams: location
        }, {}, {
            partner: 806,
            location: {
                latitude: location === null || location === void 0 ? void 0 : location.actualLatitude,
                longitude: location === null || location === void 0 ? void 0 : location.actualLongitude
            }
        });
        const { resultCode: claimCouponCode, resultMessage: claimMessage, data: claimCouponData } = claimRes || {};
        const { detailList } = claimCouponData || {};
        const codeToastMap = new Map([[EResultCode.SUCCESS, toastConfig.successTip], [EResultCode.ISSUE_FAIL, toastConfig.totalFailTip], [EResultCode.NOT_START, toastConfig.notStartTip], [EResultCode.RISK_CONTROL, toastConfig.noPortraitTip], [EResultCode.STOCK_NOT_ENOUGH, toastConfig.soldOutTip], [EResultCode.NO_USER_QUALIFICATION, toastConfig.receivedIneligibility], [EResultCode.ISSUE_NUM_LIMIT, '领取失败，请刷新页面后重试'], [EResultCode.RATE_LIMIT, toastConfig.ratelimit[0]]]);
        if (claimCouponCode === EResultCode.STOCK_NOT_ENOUGH || claimCouponCode === EResultCode.SUCCESS && (detailList || []).length) {
            // 领券成功或库存不足刷新券状态，位置不变
            try {
                const couponKeyArr = couponConfig.map(item => item.couponKey);
                toastTip = codeToastMap.get(claimCouponCode);
                const res = yield presendRequest({
                    pageId,
                    moduleId: _moduleId,
                    campaignKeys: couponKeyArr,
                    mmcParams: location
                }, formatCouponConfigRes, {
                    rootTag
                });
                if (!res)
                    return;
                const { couponList, currentTimeMillis } = res || {};
                setCurrentTimeMillis(currentTimeMillis);
                updateCouponList(couponList || []);
            }
            catch (e) {
                reportLog(`神券预发券报错-领券后-${claimCouponCode}`, e);
            }
        }
        else if (claimCouponCode === EResultCode.RISK_CONTROL) {
            // 被风控优先展示后端返回的文案
            toastTip = claimMessage || codeToastMap.get(claimCouponCode) || toastConfig.totalFailTip;
        }
        else if (claimCouponCode === EResultCode.RATE_LIMIT) {
            // 被限流等领取人数过多的情况下随机一个文案展示
            const limitConfigLen = toastConfig.ratelimit.length;
            const randomIndex = Math.floor(Math.random() * limitConfigLen);
            toastTip = toastConfig.ratelimit[randomIndex];
        }
        else if (claimCouponCode === EResultCode.UN_LOGIN) {
            yield login.login();
        }
        else {
            // 其他错误展示对应配置的文案
            toastTip = codeToastMap.get(claimCouponCode) || toastConfig.totalFailTip;
        }
        toastTip && (toast === null || toast === void 0 ? void 0 : toast.show({
            content: toastTip
        }));
        claimCouponCode !== 0 && reportLog('神券领券报错', new Error(JSON.stringify({
            toastTip,
            claimRes
        })));
    });
    return <View className="magicmember-all-btn-container">
      <View onClick={handleClaimCoupon}>
        <LinearGradient className="magicmember-all-btn" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} 
    // colors={['#FF7A00', '#FF5037', '#FF2F9A', '#FF27C0']}
    colors={allCouponColor}>
          <Text style={{
            color: allCouponTextColor
        }} className="magicmember-all-btn-text">{allCouponText}</Text>
        </LinearGradient>
      </View>
    </View>;
}
